import { Toggle } from '@cinesend/ui-kit'
import { useState } from 'react'
import { DISABLED_REASONS } from '../../constants/disabled_reasons'
import DisabledTooltip from '../disabled_tooltip'

const IsMultiSelect = ({ field, saveField }) => {
  const [isMultiSelect, setIsMultiSelect] = useState(field.is_multi_select)
  const isLocked = field?.uneditable_when_locked_attributes?.includes('is_multi_select') ?? false
  return (
    <DisabledTooltip reason={isLocked ? DISABLED_REASONS.schemaLocked : null}>
      <Toggle
        pressed={isMultiSelect}
        text='Is Multi Select'
        onToggle={() => {
          setIsMultiSelect(!isMultiSelect)
          saveField({ is_multi_select: !isMultiSelect })
        }}
        disabled={isLocked}
      />
    </DisabledTooltip>
  )
}

export default IsMultiSelect
